<template>
    <section class="sectionDiv"
             id="portfolio"
             style="height: 240vh; background-color: #171c21; padding-top: 10%; margin-bottom: 0px">

        <h1 data-aos-easing="ease-in-out"
            id="projectHeader"
            style="font-size: 60px;"
            data-aos-delay="0"
            data-aos-duration="2000"
            data-aos="fade-in"> My Work</h1>
        <p style=""></p>
        <div class="container"
             style="margin: 5% auto;">
            <div class="row ">

                <div class="col-md-12 portfolioCard cardLight">
                    <div class="row">
                        <div data-aos-easing="ease-in-out"
                             data-aos-delay="0"
                             data-aos-duration="1000"
                             data-aos="fade-in"
                             class="col-md-6 col-sm-12">
                            <h1 class="portfolioH1">Moonglade</h1>

                            <p style="color: white; text-align: left;"><i style='font-size: 13px;'>Front-end application
                                    powered by
                                    OpenAI's ChatGPT-3 models.</i><br /><br />Moonglade.ai is a conversational AI platform
                                that enables
                                users and organizations quickly create natural language-based intelligent chatbot by
                                leveraging OpenAI's
                                large-scale language models. <br><br> Built with React, Node.js, Express & OpenAI.</p>
                        </div>

                        <div class="col-md-6 col-xs-12">
                            <img data-aos-easing="ease-in-out"
                                 data-aos-delay="100"
                                 data-aos-duration="1400"
                                 data-aos="fade-in"
                                 class="portfolioImg "
                                 src="../../src/assets/moonglade_compressed.webp" />
                        </div>

                        <hr style="border-top: 1px solid white; margin: 20px" />

                        <div data-aos-easing="ease-in-out"
                             data-aos-delay="0"
                             data-aos-duration="500"
                             data-aos="fade-in"
                             class="col-12 d-flex justify-content-center"
                             style="color: white">
                            <h3><a target="_blank"
                                   href="https://github.com/moongl4de/ChatGPT-React"><i class="fab fa-github"></i>
                                    GitHub</a></h3>
                        </div>

                    </div>

                </div>
                <p style="margin: 20px;"></p>

                <div data-aos-easing="ease-in-out"
                     data-aos-delay="0"
                     data-aos-duration="500"
                     data-aos="fade-in"
                     class="col-md-12 portfolioCard cardDark">
                    <div class="row">

                        <div class="col-md-6 col-xs-12">
                            <img data-aos-easing="ease-in-out"
                                 data-aos-delay="100"
                                 data-aos-duration="1000"
                                 data-aos="fade-in"
                                 class="portfolioImg "
                                 src="../../src/assets/wowdb.webp" />
                        </div>
                        <div data-aos-easing="ease-in-out"
                             data-aos-delay="0"
                             data-aos-duration="500"
                             data-aos="fade-in"
                             class="col-md-6 col-sm-12">
                            <h1 class="portfolioH1">World of Warcraft DB</h1>

                            <p style="color: white; text-align: left;"><i style='font-size: 13px;'>A database for the best
                                    possible
                                    items for each class in World of Warcraft: Classic</i><br /> <br />Do you really have
                                time to scour
                                countless websites, compare every item in the game & run mathematical equations to get that
                                0.01%
                                advantage over the competition? World of Warcraft DB does all of the heavy lifting for you.
                                Now go kill
                                some dragons.<br /><br />Built with React, Node.js, Express and MySQL/Sequelize.</p>
                        </div>

                        <hr style="border-top: 1px solid white; margin: 20px" />

                        <div data-aos-easing="ease-in-out"
                             data-aos-delay="0"
                             data-aos-duration="500"
                             data-aos="fade-in"
                             class="col-12 d-flex justify-content-center"
                             style="color: white">
                            <h3><a target="_blank"
                                   href="https://github.com/moongl4de/world-of-warcraft-db"><i class="fab fa-github"></i>
                                    GitHub</a>
                            </h3>
                        </div>

                    </div>

                </div>

                <p style="margin: 20px;"></p>



                <div class="col-md-12 portfolioCard cardLight">
                    <div class="row">
                        <div data-aos-easing="ease-in-out"
                             data-aos-delay="0"
                             data-aos-duration="500"
                             data-aos="fade-in"
                             class="col-md-6 col-sm-12">
                            <h1 class="portfolioH1">PI Legal</h1>

                            <p style="color: white; text-align: left;"><i style='font-size: 13px;'>A case management
                                    application for
                                    law firms to log payments, generate documents and monitor the progress of
                                    cases</i><br /><br />PI
                                Legal is a robust case management application currently being used by Cambre & Associates in
                                Atlanta,
                                Georgia. <br /><br> Some of the most recent features I've implemented are report generation,
                                an in-house
                                API for client data retrieval, negotiation offer/demand tracking, statute of limitation
                                alerts, an
                                automated e-mail notification system.<br /><br />Built with Vue, Node.js, Express, FileMaker
                                Pro</p>


                        </div>

                        <div class="col-md-6 col-xs-12">
                            <img data-aos-easing="ease-in-out"
                                 data-aos-delay="100"
                                 data-aos-duration="500"
                                 data-aos="fade-in"
                                 class="portfolioImg "
                                 src="../../src/assets/pilegal-dash.jpg" />
                        </div>

                        <hr style="border-top: 1px solid white; margin: 20px" />

                        <div data-aos-easing="ease-in-out"
                             data-aos-delay="0"
                             data-aos-duration="500"
                             data-aos="fade-in"
                             class="col-12 d-flex justify-content-center"
                             style="color: white">
                            <h6><i>Proprietary Application / Private Repo</i></h6>
                        </div>

                    </div>

                </div>

                <p style="margin: 20px;"></p>

                <div data-aos-easing="ease-in-out"
                     data-aos-delay="0"
                     data-aos-duration="500"
                     data-aos="fade-in"
                     class="col-md-12 portfolioCard cardDark">
                    <div class="row">

                        <div class="col-md-6 col-xs-12">
                            <img data-aos-easing="ease-in-out"
                                 data-aos-delay="100"
                                 data-aos-duration="1000"
                                 data-aos="fade-in"
                                 class="portfolioImg "
                                 src="https://raw.githubusercontent.com/alexgignilliat/Digital-Asset-Monitor/master/DAM2ss.png" />
                        </div>
                        <div data-aos-easing="ease-in-out"
                             data-aos-delay="0"
                             data-aos-duration="1000"
                             data-aos="fade-in"
                             class="col-md-6 col-sm-12">
                            <h1 class="portfolioH1">Digital Asset Monitor</h1>

                            <p style="color: white; text-align: left;"><i style='font-size: 13px;'>A minimalist approach to
                                    tracking
                                    price & news for some of the most popular digital assets.</i><br /><br />Digital Asset
                                Monitor
                                provides users with prices, news articles and latest tweets for Bitcoin, Ethereum and XRP
                                <br>
                                <br />Built with HTML/CSS, JavaScript, jQuery and several APIs (Twitter, Nomics, etc)
                            </p>
                        </div>

                        <hr style="border-top: 1px solid white; margin: 20px" />

                        <div data-aos-easing="ease-in-out"
                             data-aos-delay="0"
                             data-aos-duration="500"
                             data-aos="fade-in"
                             class="col-12 d-flex justify-content-center"
                             style="color: white">
                            <h3><a target="_blank"
                                   href="https://github.com/moongl4de/digital-asset-monitor"><i class="fab fa-github"></i>
                                    GitHub</a>
                            </h3>
                        </div>

                    </div>

                </div>

                <p style="margin: 20px;"></p>

                <div class="col-md-12 portfolioCard cardLight">
                    <div class="row">
                        <div data-aos-easing="ease-in-out"
                             data-aos-delay="0"
                             data-aos-duration="500"
                             data-aos="fade-in"
                             class="col-md-6 col-sm-12">
                            <h1 style="color: #1594f3;; font-size: 3rem; margin: 1%; text-align: left;">Bandwagon</h1>

                            <p style="color: white; text-align: left;"><i style='font-size: 13px;'>A digital music streaming
                                    platform
                                    designed with listeners and artists in mind.</i><br /><br />Users are allotted a number
                                of tokens
                                based on their subscription plan. Every time a user streams a song, a microtransaction takes
                                place
                                sending a fraction of a token directly to the artist. This model completely removes
                                middlemen cutting
                                into the artists' profits. <br /><br /> Future development roadmap entails utilizing <span
                                      class="blueSpan">XRP</span> instead of the Bandwagon token. <br /><br />Built with
                                React, Node.js,
                                Express, MongoDB and AWS S3.</p>
                        </div>
                        <div class="col-md-6 col-xs-12">
                            <img data-aos-easing="ease-in-out"
                                 data-aos-delay="100"
                                 data-aos-duration="500"
                                 data-aos="fade-in"
                                 class="portfolioImg "
                                 src="https://raw.githubusercontent.com/alexgignilliat/bandwagon/master/client/src/img/bandwagon-listener.png" />
                        </div>

                        <hr style="border-top: 1px solid white; margin: 20px" />

                        <div data-aos-easing="ease-in-out"
                             data-aos-delay="0"
                             data-aos-duration="500"
                             data-aos="fade-in"
                             class="col-12 d-flex justify-content-center"
                             style="color: white">
                            <h3><a target="_blank"
                                   href="https://github.com/moongl4de/bandwagon"><i class="fab fa-github"></i> GitHub</a>
                            </h3>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <a data-scroll
           href="#"
           class=""><button style="border-radius: 0px; min-width: 10%"
                    class="btn portfolioButton hvr-underline-from-left">
                Back to Top
            </button></a>

    </section>
</template>
  
<script>
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";


export default {
    props: {
        testProp: String
    },

    created() {


    },

    data() {
        return {

            introHeader: "",
            colorVanta: "rgb(24, 154, 243)",
            backgroundColorVanta: "red",
            options: {
                mouseControls: true,
                touchControls: true,
                minHeight: 500.00,
                minWidth: 200.00,
                scale: 1.00,
                scaleMobile: 1.00
            },
            methods: {
                headerChange: function () {
                    this.introHeader = "hehrhsdjkfhs";
                },
            },

        };
    },

    name: "MyWork",



};
</script>
  

  